<template>
  <div>
    <!-- Inbox Filter -->
    <!-- <div class="msg-search">
      <b-form-group
        class="mb-0"
      >
        <b-input-group class="input-group-merge input-search">
          <b-form-input
            id="filterInbox"
            type="search"
            placeholder="Search message"
          />
          <b-input-group-append is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div> -->
    <!-- End Inbox Filter -->
    <div class="head-list-msg">
      <b-form-checkbox
        v-model="allSelected"
        class="check-inbox custom-control-danger"
        @change="toggleAll"
      />
      <h4 class="py-2">
        Inbox
      </h4>
      <div
        v-if="showButtonDelete"
        class="btn-del"
        @click.prevent="deleteMessage"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 37 37"
          fill="none"
          stroke="#625f6e"
          stroke-linejoin="round"
          stroke-width="3.4"
          stroke-linecap="round"
        >
          <path d="m5.8575 11.256v18.792c0 2.8873 2.3248 5.2116 5.2121 5.2116h14.21c2.8873 0 5.2116-2.3243 5.2116-5.2116v-18.859" />
          <path d="m4.0754 5.0858h28.198c1.5677 0 2.8299 1.2621 2.8299 2.8299 0 1.5677-1.2621 2.8299-2.8299 2.8299h-28.198c-1.5677 0-2.8299-1.2621-2.8299-2.8299 0-1.5677 1.2621-2.8299 2.8299-2.8299z" />
          <path d="m24.756 5.0857v-1.8583c0-1.0365-0.83421-1.8712-1.8707-1.8712h-9.4216c-1.0365 0-1.8707 0.83473-1.8707 1.8712v1.8583" />
          <path d="m23.068 16.134v12.361m-9.7876 0v-12.361" />
        </svg>
      </div>
    </div>
    <!-- Inbox List -->
    <div
      class="msg-list"
    >
      <vue-perfect-scrollbar
        :settings="settings"
        class="scroll-area"
      >
        <div
          v-for="obj in listMessages"
          :key="obj.id"
          class="msg-list-nm"
          :class="[{ 'active': obj.id === openMessage },{ 'unread': obj.status === '0' }]"
        >
          <b-form-checkbox
            :key="`c-${obj.id}`"
            v-model="message"
            :value="obj.id"
            class="check-inbox custom-control-danger"
            @change="checkMessage"
          />
          <div
            @click="readMessage(obj.id)"
          >
            <span :class="'b-avatar b-avatar rounded-circle '+statusMessage[1][obj.type]">
              <feather-icon
                :icon="statusMessage[0][obj.type]"
                class="align-middle"
              />
            </span>
            <div class="msg-list-nmc">
              <h6>{{ obj.title }} </h6>
              <span class="msg-time">{{ timeSince(obj.time) }}</span>
            </div>
          </div>
        </div>
      </vue-perfect-scrollbar>
    </div>
    <!-- End Inbox List -->
  </div>
</template>
<script>

// import {
//   BInputGroup,
//   BFormInput,
//   BInputGroupAppend,
//   BFormGroup,
// } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions } from 'vuex'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  components: {
    // BInputGroup,
    // BFormInput,
    // BInputGroupAppend,
    // BFormGroup,
    VuePerfectScrollbar,
    BFormCheckbox,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    listMessages: null,
    // eslint-disable-next-line vue/require-default-prop
    statusMessage: null,
    // eslint-disable-next-line vue/require-default-prop
    openMessage: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 3,
        wheelPropagation: false,
      },
      showButtonDelete: false,
      message: [],
      listId: [],
      allSelected: false,
    }
  },
  mounted() {
    this.listMessageId()
  },
  methods: {
    ...mapActions('inbox', [
      'updateStatus',
      'deleteMessages',
    ]),
    readMessage(val) {
      this.$emit('openMessageCall', val)
      this.$store.commit('inbox/SET_DATA_OPEN', val)
      let sendData = {
        id: val,
      }
      this.updateStatus(sendData).then(() => {
        this.$store.dispatch('inbox/listInbox')
      })
    },
    listMessageId() {
      this.listId = this.listMessages.map(item => item.id)
    },
    checkMessage(checked) {
      this.message = checked
      // eslint-disable-next-line no-unneeded-ternary
      this.showButtonDelete = (this.message.length === 0) ? false : true
    },
    toggleAll(checked) {
      this.message = checked ? this.listId.slice() : []
      // eslint-disable-next-line no-unneeded-ternary
      this.showButtonDelete = (this.message.length === 0) ? false : true
    },
    deleteMessage() {
      let sendData = {
        id: this.message,
      }
      this.$emit('closeMessageCall')
      this.deleteMessages(sendData).then(() => {
        // eslint-disable-next-line no-restricted-globals
        this.$emit('refreshList')
      })
    },
    timeSince(date) {
      let dd = date.replace(/-/g, '/')
      let gdate = new Date(dd)
      let seconds = Math.floor((new Date() - gdate) / 1000)
      let interval = seconds / 31536000
      let mArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      if (interval > 1) {
        return `${(`0${gdate.getDate()}`).slice(-2)} ${(` ${(mArray[gdate.getMonth()])}`)} ${(`${gdate.getFullYear()}`)} ${(` ${(this.formatAMPM(gdate))}`)}`
      }
      interval = seconds / 2592000
      if (interval > 1) {
        return `${(`0${gdate.getDate()}`).slice(-2)} ${(` ${(mArray[gdate.getMonth()])}`)} ${(` ${(this.formatAMPM(gdate))}`)}`
      }
      interval = seconds / 86400
      if (interval > 1) {
        return `${(`0${gdate.getDate()}`).slice(-2)} ${(` ${(mArray[gdate.getMonth()])}`)} ${(` ${(this.formatAMPM(gdate))}`)}`
      }
      interval = seconds / 3600
      if (interval > 1) {
        return Math.floor(interval) === 1 ? 'a hour ago' : `${Math.floor(interval)} hours ago`
      }
      interval = seconds / 60
      if (interval > 1) {
        return Math.floor(interval) === 1 ? 'a minute ago' : `${Math.floor(interval)} minutes ago`
      }
      return Math.floor(seconds) === 1 ? 'a second ago' : `${Math.floor(seconds)} seconds ago`
    },
    formatAMPM(date) {
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      hours %= 12
      hours = hours || 12
      hours = `${(`0${hours}`).slice(-2)}`
      minutes = `${(`0${minutes}`).slice(-2)}`
      let strTime = `${hours}:${minutes} ${ampm}`
      return strTime
    },
  },
}
</script>
<style scoped>
.table th, .table td {
  padding: 0.2rem !important;
}
.inbox-wrapper{
  height: calc(100vh - 2.5rem);
  padding-bottom: 5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.inbox-wrap{
  background: #EFEFEF;
  border-radius:5px;
  height:100%;
  overflow: hidden;
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
}
.left-inbox{
  height:100%;
  background: #fff;
  border-right: 1px solid #e0e0e0;
}
.right-inbox{
  background: #efefef;
}
.left-inbox,.right-inbox{
  padding:0;
}
.flex-fill {
    flex:1 1 auto;
}
.msg-head{
  height:62px;
  background: #fff;
  position: relative;
}
.msg-head-left .avatar{
  width:40px;
  height:40px;
  overflow: hidden;
  border-radius:20px;
  position: absolute;
  top: 11px;
  left: 19px;
}
.msg-head-left h4{
  position: absolute;
  font-weight: 1000;
  color: #000;
  top: 21px;
  left: 76px;
}
.msg-search{
  height:62px;
  border-bottom:#EBE9F1 1px solid;
  padding:10px;
}
.msg-content{
  background: #fff;
  border-radius:10px;
  min-height:50vh;
  margin: 10px;
  padding:20px;
}
.msg-list-nm{
  position: relative;
  padding:10px;
  border-bottom: 1px solid #EBE9F1;
  min-height:80px;
  cursor: pointer;
}
.msg-list-nmc{
  padding-left:90px;
}
.msg-list-nmc h6, .left-inbox h4{
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  color: #5E5873;
  font-weight: 600;
}
.left-inbox h4{
  font-size: 18px;
  padding: 12px 26px;
  margin: 0;
  padding-left: 3.5rem;
}
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 18rem);
}
.msg-time{
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #B9B9C3;
}
.msg-sym{
  width: 32px;
    height: 32px;
    position: absolute;
    border-radius: 16px;
    left:22px;
}
.b-avatar{
  position:absolute;
  left:3.5rem;
}
.active, .active.unread{
  background-color:#4B6AAE;
}
.unread{
  background-color: #f5f5f5;
}
.active .msg-list-nmc h6, .active .msg-time{
  color: #fff;
}
.active svg.feather{
  stroke: #fff;
}
.active .b-avatar{
  background-color:rgb(255 255 255 / 18%);
}
.msg-head-right{
    text-align: left;
    position: absolute;
    right: 30px;
    top: 20px;
}
.msg-head-right span{
  color:#B9B9C3;
  margin-right:20px;
}
.msg-head-right svg{
  stroke:rgb(58, 58, 58);
}
.input-search{
  width: auto !important;
}
.check-inbox{
  width: 43px;
  display: block;
  position: absolute;
  margin: auto;
  top: calc(50% - 12px);
  left: 1rem;
}
.head-list-msg{
  position: relative;
}
.btn-del{
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  width:22px;
  cursor: pointer;
}
</style>
